import { PointerEvent } from "react";
import { entries, keys } from "../common/util/ObjectEntries";
import { CHILD_TYPES, TAnyNodeID } from "./_generated/NodeTypes";
import { useSharedState, useSharedStateWriteOnly } from "./app/useSharedState";
import "./Control.css";
import { GridControl } from "./controls/GridControl";

function getControlViewportPosition(id: TAnyNodeID) {
  const { x, y } = document.getElementById(id)!.getBoundingClientRect();
  return [x, y];
}

function getControlViewportSize(id: TAnyNodeID) {
  const { width, height } = document
    .getElementById(id)!
    .getBoundingClientRect();
  return [width, height];
}

export function getControlHandleId(id: TAnyNodeID, side: "left" | "right") {
  return `${id}:${side}`;
}

export default function Control({
  id,
  onDragBegin,
}: {
  id: TAnyNodeID;
  onDragBegin: (e: PointerEvent) => void;
}) {
  const [scene, setScene] = useSharedState("scene");
  const [holdingState, setHoldingState] = useSharedState("holdingState");
  const [, setSelection] = useSharedStateWriteOnly("selection");
  const [, setActiveContextMenu] = useSharedStateWriteOnly("activeContextMenu");

  const control = scene.nodes[id];

  return (
    <div className="control">
      <div
        id={id}
        className="control-row"
        onContextMenu={(e) => {
          e.preventDefault();
          setActiveContextMenu({
            type: "control",
            controlId: id,
            position: [e.clientX, e.clientY],
          });
        }}
      >
        <div onPointerDown={onDragBegin}>{control.type}</div>
        {/* {spec.hasInput?.(scene, controlId) ? (
          <div
            className="control-left-edge"
            onPointerDown={() => {
              if (holdingState !== null && holdingState.holdingSide === "end") {
                console.log(
                  addWire(scene, holdingState.connectedControl, controlId)
                );
                setScene(
                  addWire(scene, holdingState.connectedControl, controlId)
                );
                setHoldingState(null);
                return;
              }
              setHoldingState({
                type: "edit_wire",
                holdingSide: "start",
                connectedControl: controlId,
              });
            }}
          >
            <div
              id={getControlHandleId(controlId, "left")}
              className="control-edge-line"
            />
          </div>
        ) : null}
        {spec.hasOutput?.(scene, controlId) ? (
          <div
            className="control-right-edge"
            onPointerDown={() => {
              if (
                holdingState !== null &&
                holdingState.holdingSide === "start"
              ) {
                setScene(
                  addWire(scene, controlId, holdingState.connectedControl)
                );
                setHoldingState(null);
                return;
              }
              setHoldingState({
                type: "edit_wire",
                holdingSide: "end",
                connectedControl: controlId,
              });
            }}
          >
            <div
              id={getControlHandleId(controlId, "right")}
              className="control-edge-line"
            />
          </div>
        ) : null} */}
      </div>
      {/* {"children" in control
        ? entries(control.children)
            // .filter((v) => v !== undefined)
            .map(([key, children]) => {
              switch (CHILD_TYPES[control.type][key]) {
                case "grid_list":
                  return keys(children).map((v) => <GridControl id={v} />);
                case "line_list":
                  return <ControlLineList list={children} />;
                case "required":
                case "optional":
                  return children === undefined ? null : (
                    <Control id={children} />
                  );
              }
            })
        : null} */}
      {/* {"children" in control
        ? entries(control.children).map(([key, children]) => {
            // optional
            if (children === undefined) {
              return null;
            }
            // line_list
            if (Array.isArray(children)) {
              return null;
            }
            if (typeof children === "object") {
              // grid_map
              if (key === "props" || key === "events") {
                return entries(children).map(([_, v]) => (
                  <GridControl id={v} />
                ));
              }
              // grid_set
              return keys(children).map((v) => <GridControl id={v} />);
            }
            // required
            // TODO: Determine if it goes in line or grid
            return <GridControl id={children} />;
          })
        : null} */}
      {"children" in control
        ? entries(control.children).map(([key, children]) => {
            switch (CHILD_TYPES[control.type][key]) {
              case "line_list":
                // return <ControlLineList parent={[id, key]} />;
                return null;
              case "grid_list":
                return keys(children).map((v) => <GridControl id={v} />);
              case "grid_map":
                return Object.values(children).map((v) => (
                  <GridControl id={v} />
                ));
              case "optional":
                return children === undefined ? null : (
                  <GridControl id={children} />
                );
            }
          })
        : null}
    </div>
  );
}
